import { render } from "./chartH.vue?vue&type=template&id=c9670ec2"
import script from "./chartH.vue?vue&type=script&lang=ts"
export * from "./chartH.vue?vue&type=script&lang=ts"
script.render = render

export default script